<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}发票抬头`"
    width="900px"
    height="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="editLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="抬头类型" prop="type">
            <el-radio-group v-model="editForm.type" placeholder="请选择">
              <el-radio-button :label="0">个人</el-radio-button>
              <el-radio-button :label="1">公司</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="抬头名称" prop="ivName">
            <el-input v-model.trim="editForm.ivName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位税号" prop="ivNo">
            <el-input v-model.trim="editForm.ivNo" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册地址" prop="ivAddress">
            <el-input v-model.trim="editForm.ivAddress" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册电话" prop="ivPhone">
            <el-input v-model.trim="editForm.ivPhone" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行" prop="ivBank">
            <el-input v-model.trim="editForm.ivBank" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号" prop="ivAccount">
            <el-input v-model.trim="editForm.ivAccount" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getInvoiceTitle, editInvoiceTitle } from '@/api/invoice';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: {
        type: 1
      },
      rules: {
        ivName: [{ required: true, message: '请输入抬头名称', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.editLoading = true;
      try {
        const { data } = await getInvoiceTitle({ id: this.activeId });
        this.editForm = {
          type: data.type,
          devName: data.devName,
          ivNo: data.ivNo,
          ivAddress: data.ivAddress,
          ivPhone: data.ivPhone,
          ivBank: data.ivBank,
          ivAccount: data.ivAccount
        };
      } finally {
        this.editLoading = false;
      }
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          try {
            await editInvoiceTitle(this.editForm);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped></style>
